import { schema } from "normalizr";

const reaction = new schema.Entity(`reactions`);
const arrayOfReactions = [reaction];

export { reaction, arrayOfReactions };
